export default {
  init() {
    // JavaScript to be fired on the home page
    // console.log('init homepage');
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js